import React, { useMemo } from 'react';
import BankSettingsField from './components/BankSettingsField/BankSettingsField';
import AddNewBlockBtn from './components/AddNewBlockBtn';
import { IDeviceBankSettingForCreate } from 'types';
import style from './BankSettingsBlock.module.scss';

interface IBankSettingsBlock {
	bankSettings: IDeviceBankSettingForCreate[];
}

const BankSettingsBlock: React.FC<IBankSettingsBlock> = ({ bankSettings }) => {
	const bankSettingFields = useMemo(() => {
		return bankSettings.map((el) => <BankSettingsField key={el.id} data={el} />);
	}, [bankSettings]);

	return (
		<div className={style.container} data-test="BankSettingsBlock">
			{bankSettings.length ? bankSettingFields : <div className={style.divider} />}
			<AddNewBlockBtn />
		</div>
	);
};

export default React.memo(BankSettingsBlock);
